export default {
  VIDEOS: "Videos",
  VIDEO: "Video",
  BACKTOVIDEOS: "Back to Videos",
  WATCHOTHERVIDEOS: "Watch Other Videos",
};
